import CategoriesRequests from '../../server/categories';
import { addLoading, removeLoading } from './loading';

export const getCategories = res => ({
  type: 'GET_CATEGORIES',
  categories: res,
});

export const getCategoriesFeatured = res => ({
  type: 'GET_CATEGORIES_FEATURED',
  categoriesFeatured: res,
});

export const getCategoriesAction = () => async (dispatch) => {
  dispatch(addLoading());
  try {
    const categories = await CategoriesRequests.getCategories();
    dispatch(getCategories(categories));
  } finally {
    dispatch(removeLoading());
  }
};

export const createCategoryAction = category => async (dispatch) => {
  dispatch(addLoading());
  try {
    const newCategory = await CategoriesRequests.createCategory(category);
    dispatch(getCategories([newCategory]));
    return newCategory;
  } finally {
    dispatch(removeLoading());
  }
};

export const removeCategoryAction = id => async (dispatch) => {
  dispatch(addLoading());
  try {
    await CategoriesRequests.removeCategory(id);
  } finally {
    dispatch(removeLoading());
  }
};

export const updateCategoryAction = category => async (dispatch) => {
  dispatch(addLoading());
  try {
    return await CategoriesRequests.updateCategory(category);
  } finally {
    dispatch(removeLoading());
  }
};

export const updateCategoriesAction = categories => async (dispatch) => {
  dispatch(addLoading());
  try {
    await CategoriesRequests.updateCategories(categories);
  } finally {
    dispatch(removeLoading());
  }
};

export const getCategoriesFeaturedAction = () => async (dispatch) => {
  try {
    const categories = await CategoriesRequests.getCategoriesFeatured();
    dispatch(getCategoriesFeatured(categories));
  } finally {
    // dispatch(removeLoading());
  }
};

export const updateCategoryImage = (file, categoryId) => async (dispatch) => {
  dispatch(addLoading());
  try {
    await CategoriesRequests.uploadImage(file, categoryId);
  } finally {
    dispatch(removeLoading());
  }
};

export const uploadCategories = file => async (dispatch) => {
  dispatch(addLoading());
  try {
    await CategoriesRequests.uploadCsvCategories(file);
  } finally {
    dispatch(removeLoading());
  }
};

export const getCsvCategoriesModel = () => async (dispatch) => {
  dispatch(addLoading());
  try {
    await CategoriesRequests.getCsvCategoriesModel();
  } finally {
    dispatch(removeLoading());
  }
};

export const getCsvCategoriesReport = () => async (dispatch) => {
  dispatch(addLoading());
  try {
    await CategoriesRequests.getCsvCategoriesReport();
  } finally {
    dispatch(removeLoading());
  }
};

export const updateCategoryStatus = categoryId => async (dispatch) => {
  dispatch(addLoading);
  try {
    return await CategoriesRequests.updateCategoryStatus(categoryId);
  } finally {
    dispatch(removeLoading);
  }
};
